import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// POST: Login the user - Not a protected route
async function httpLoginUser(userInfo) {
  try {
    return await fetch(`${API_URL}/users/auth/login`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userInfo),
    });
  } catch (err) {
    return err;
  }
}

//POST: Sign Up User - Not a protected route
async function httpSignUpUser(userInfo) {
  try {
    return await fetch(`${API_URL}/users/auth/signup`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userInfo),
    });
  } catch (err) {
    return err;
  }
}

//POST: Forgot Password - Not a protected route
async function httpForgotPassword(email) {
  try {
    return await fetch(`${API_URL}/users/auth/forgot-password`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
  } catch (err) {
    return err;
  }
}

//POST: Reset Password - Not a protected route
async function httpResetPassword(token, password) {
  try {
    return await fetch(`${API_URL}/users/auth/reset-password`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, password }),
    });
  } catch (err) {
    return err;
  }
}
// POST: Upload Certificate - Protected route
async function httpUploadCertificate(formData) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/certs/upload-certificate`, {
      method: 'post',
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: formData,
    });
  } catch (err) {
    return err;
  }
}
// POST: Send/Set Reminder Email - Protected route
async function httpSendReminderEmail(course) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/courses/send-reminder-email`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(course),
    });
  } catch (err) {
    return err;
  }
}

// POST: Add to Cart - Protected route
async function httpAddToCart({
  courseId,
  userId,
  productId,
  itemType = 'course',
  quantity = 1,
}) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/cart/add`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ courseId, userId, productId, itemType, quantity }),
    });
  } catch (err) {
    return err;
  }
}
// POST: Remove from Cart - Protected route
async function httpRemoveFromCart({
  courseId,
  userId,
  productId,
  itemType = 'course',
}) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/cart/remove`, {
      method: 'delete',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ courseId, userId, productId, itemType }),
    });
  } catch (err) {
    return err;
  }
}
// POST: Clear Cart - Protected route
async function httpClearCart(userId) {
  // console.log('Clearing cart for userId:', userId);
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/cart/clear`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ userId }),
    });
  } catch (err) {
    return err;
  }
}

// POST: Adds User Certificate
async function httpAddUserCertficate(formData) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/certs/add`, {
      method: 'post',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ formData }),
    });
  } catch (err) {
    return err;
  }
}

// POST: Favorite and Unfavorite a form
async function httpToggleFavoriteForm(formId, userId) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/users/actions/favorite-form`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ userId, formId }),
    });
  } catch (err) {
    return err;
  }
}

// POST: Submits a section of the quiz for a user - Protected route
async function httpSubmitSectionQuiz(sectionData, userId) {
  const token = Auth.getToken();

  try {
    const response = await fetch(
      `${API_URL}/users/courses/submit-section-quiz`,
      {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: JSON.stringify({
          sectionData,
          userId,
        }),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result?.msg || 'Unable to submit section quiz.');
    }

    return result;
  } catch (err) {
    console.error('Error submitting section quiz:', err);
    throw err;
  }
}

export {
  httpForgotPassword,
  httpLoginUser,
  httpResetPassword,
  httpSignUpUser,
  httpUploadCertificate,
  httpAddToCart,
  httpRemoveFromCart,
  httpSendReminderEmail,
  httpClearCart,
  httpAddUserCertficate,
  httpToggleFavoriteForm,
  httpSubmitSectionQuiz,
};
